import Tag from './view';
export default Tag;
